<template>
  <div class="game" :style="{height: height,width:width}">
    <iframe id="receiverIframe" src="" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
  import {hex_md5} from '../utils/md5.js'
  import { mapMutations } from 'vuex'
  import { mapState } from 'vuex'
  export default {
    data(){
      return{
        agree:false,
        haslogin:true,
        nicname:'',
        phoneNum:"",
        appSecret : "b43f0148b81511957b28e011584ea4c73570f700784cdf7891f1c040a353baca",
        clientType:3,
        captcha:"",
        countDown:120,
        countFunction:null,
        errDesc:{
          1007:"手机号输入有误请从新输入"
        },
        gameInfo:{},
        urlParams:"",
        fromParam:{},
        eventName:"",
        cbDispatcher:"",
        callbackId:"",
        receiver:"",
        height:window.innerHeight+"px",
        width:window.innerWidth+"px"
      }
    },
    mounted:function(){
      this.getGameInfo();
    },
    methods:{
      ...mapMutations([
        'setUser','setLoginState','logout','setGameInfo'
      ]),
      open(msg='兑换失败',callback) {
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(callback){
            callback()
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      changePage(path){
        this.$router.push(path)
      },
      //nonce生成*位随机串
      getNonce(len, charSet){
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length);
          randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
      },
      sign(method,appId,nonce,timestamp,signUrl,appSec){
        var str = method + 'X-QP-AppId:'+appId+'X-QP-Nonce:'+nonce+'X-QP-Timestamp:'+timestamp+signUrl+appSec;
        var newStr = hex_md5(str).toUpperCase();
        return newStr;
      },
      getOS(){
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          return 'ios';
        } else if (/(Android)/i.test(navigator.userAgent)) {
          return 'android';
        }
      },
      getGameInfo(){//获取游戏信息
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.ganmeInfo + '?appKey='+this.$ajaxUrls.appKey;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':880004,
            'X-Qp-Gid': this.userData.gid,
            'X-QP-UserId': this.userData.userId,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',880004,lnonce,ltimestamp,url,this.appSecret)
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.gameInfo = res.data.data;
            this.setGameInfo(res.data.data);
            this.authentication();
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      authentication(){//认证服务
        var aurl = this.$ajaxUrls.uc+'/auth/v1/accessToken?appKey='+this.$ajaxUrls.appKey+'&gid='+this.userData.gid;
        var atimestamp = new Date().getTime().toString().substring(0,10);
        var anonce = new Date().getTime().toString() + this.getNonce(19);
        this.$axios({
          url: aurl,
          method: 'get',
          headers:{
              'X-QP-AppId': 880004,
              'X-QP-AppVersion': '1.0.1',
              'X-QP-ResVersion': '1.0.1',
              'X-QP-OS': this.getOS(),
              'X-QP-OSVersion': '',
              'X-QP-ClientType': this.clientType,
              'X-QP-UserId': this.userData.userId,
              'X-QP-Gid': this.userData.gid,
              'X-QP-Timestamp': atimestamp,
              'X-QP-Nonce': anonce,
              'X-QP-Signature': this.sign('GET',880004,anonce,atimestamp,aurl,this.appSecret),
              'X-QP-Token': this.userData.accessToken,
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.urlParams = '?openId='+res.data.data.openid+'&accessToken='+res.data.data.accessToken+'&nonceStr='+res.data.data.nonceStr+'&timestamp='+res.data.data.timestamp+'&sign='+res.data.data.sign+"&clientType=3";
            var ssrc =this.gameInfo.accessUrl+this.urlParams;
            console.log(ssrc);
            $('#receiverIframe').attr('src',ssrc);
            this.addEvent();
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      addEvent(){
        this.receiver = $('#receiverIframe')[0].contentWindow;
        window.addEventListener('message', this.receiveMessage, false);  //接收消息监听
      },
      sendMessage(status) {
        var objstr = JSON.stringify(status);
        this.receiver.postMessage(objstr, "*");
      },
      receiveMessage(event) {    //iframe内点击兑换接收消息方法
        var str = 'XLH5://?';
        if(typeof  event.data !== "string"){
          return
        }
        var str1 = event.data.substring(str.length);
        var obj = JSON.parse(str1);
        if(obj.cmd == 'registerEvents'){
          this.eventName = obj.args.eventNames[2];
        }else{
          this.fromParam = obj.args;
          this.cbDispatcher = obj.cbDispatcher;
          this.callbackId = obj.callbackId;
          console.log('命令：'+obj.cmd);
          if(obj.cmd == 'payInDiamond'){
            this.exchange(this.fromParam,this.callbackId);
          }else if(obj.cmd == 'getPlatform'){
          //  sendOS(this.callbackId);
          }else if(obj.cmd == 'getDiamondNum'){
            this.sendDiamondNum(this.callbackId);
          }
        }
      },
      exchange(param,eid){
        var eurl = this.gameInfo.mallUrl+'/co/v1/pay/exchangeProd';
        var etimestamp = new Date().getTime().toString().substring(0,10);
        var enonce = new Date().getTime().toString() + this.getNonce(19);
        this.$axios({
          url: eurl,
          method: 'post',
          data:{
            clientType: this.clientType,
            gId: parseInt(this.userData.gid),
            prepayId: param.prepayId
          },
          headers:{
            'X-QP-AppId': 880004,
            'X-QP-AppVersion': '1.0.1',
            'X-QP-ResVersion': '1.0.1',
            'X-QP-OS': this.getOS(),
            'X-QP-OSVersion': '',
            'X-QP-ClientType': this.clientType,
            'X-QP-UserId': this.userData.userId,
            'X-QP-Gid': this.userData.gid,
            'X-QP-Timestamp': etimestamp,
            'X-QP-Nonce': enonce,
            'X-QP-Signature': this.sign('POST',880004,enonce,etimestamp,eurl,this.appSecret),
            'X-QP-Token': this.userData.accessToken,
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            //兑换成功,post通信
            let postObj = {};
            postObj.callbackId = eid;
            postObj.params = {status: 0};
            this.sendMessage(postObj);
            this.sendDiamondNum();
          }else if(res.data.errCode == 30003){  //钻石不足，校验充值
            this.open("闲徕币余额不足请充值",this.changePage.bind(null,{name:'charge'}));
          }else if(res.data.errCode == 80003){  //token失效
            this.toLogout();
          }else{
            let postObj = {};
            postObj.callbackId = eid;
            postObj.params = {status: 1};
            this.sendMessage(postObj);
            this.open("兑换失败");
          }
        }).catch((err)=>{
          alert(err)
        });
      },
      sendDiamondNum(did){
        var surl = this.gameInfo.mallUrl+'/co/v1/remote/accountInfo?gId='+this.userData.gid;
        var stimestamp = new Date().getTime().toString().substring(0,10);
        var snonce = new Date().getTime().toString() + this.getNonce(19);
        this.$axios({
          url: surl,
          method: 'get',
          headers:{
            'X-QP-AppId': 880004,
            'X-QP-AppVersion': '1.0.1',
            'X-QP-ResVersion': '1.0.1',
            'X-QP-OS': this.getOS(),
            'X-QP-OSVersion': '',
            'X-QP-ClientType': this.clientType,
            'X-QP-UserId': this.userData.userId,
            'X-QP-Gid': this.userData.gid,
            'X-QP-Timestamp': stimestamp,
            'X-QP-Nonce': snonce,
            'X-QP-Signature': this.sign('GET',880004,snonce,stimestamp,surl,this.appSecret),
            'X-QP-Token': this.userData.accessToken,
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            var dia = res.data.data.diamondNum;
            let postObj = {};
            if(!!did){
              postObj.callbackId = did;
              postObj.params = {status: 0,diamondNum: dia};
            }else{
              postObj.eventName = this.eventName;
              postObj.params = {balance: dia};
            }
            this.sendMessage(postObj);
          }else if(res.data.errCode == 80003){
            this.toLogout();
          }else{
            let postObj = {};
            if(!!did){
              postObj.callbackId = did;
              postObj.params = {status: 1,diamondNum: ''};
            }else{
              postObj.eventName = this.eventName;
              postObj.params = {};
            }
            this.sendMessage(postObj);
          }
        }).catch((err)=>{
          alert(err)
        });
      },
      toLogout(){
        this.logout();
        this.$router.push({name:'home'});
      }
    },
    computed: mapState([
      'userData','asset'
    ]),
    beforeDestroy(){
      window.removeEventListener('message', this.receiveMessage, false);  //接收消息监听
    }
  }

</script>

<style lang="scss" scoped>
  @import '../components/style/mixin';
</style>
